<template>
    <div class="application" :theme="theme">
        <!-- <div class="downtime-ribbon">
            <div class="constrain bc flex flex-align">
                <div class="ff center">You may experience a brief interruption between 11pm and 12am Eastern Time as we perform system updates.</div>
            </div>
        </div> -->
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'Application',
        computed: {
            theme(){
                return this.$store.state.theme.active;
            }
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";
    @import "~@/assets/less/global";
    @import "~@/assets/less/themes";

    .application
    {
        background: var(--background-color);
        min-height: 100vh;
    }

    .downtime-ribbon
    {
        height: 48px;
        background: @red;
        color: @white;
        font-weight: 500;
        font-size: 14px;

        .constrain
        {
            height: 100%;
        }

        .text-button.border
        {
            font-size: 12px;
            padding: 2px 10px;
            margin-left: 10px;

            &:hover, &:active
            {
                background: transparent;
            }
        }
    }
</style>
